// v1.28.71 — Mac display helper: swap "Ctrl" → "⌘", "Alt" → "⌥" on macOS so
// the same stored combo ("Ctrl+D") renders as "⌘+D" for Mac users while
// staying "Ctrl+D" for Windows / Linux. The underlying keyboard listener
// already treats metaKey || ctrlKey as equivalent.
export const IS_MAC = typeof navigator !== "undefined"
    && /Mac|iPhone|iPad|iPod/.test(navigator.platform || navigator.userAgent || "");

export function displayCombo(combo) {
    if (!combo) return "";
    if (!IS_MAC) return combo;
    return combo.replace(/\bCtrl\b/gi, "⌘").replace(/\bAlt\b/gi, "⌥").replace(/\+/g, "");
}
